module.exports = __webpack_public_path__ + "img/all-workflow-2.858489e5.svg";